import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const StopwatchIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M10 9.0625V5.9375"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 3.4375V2.8125"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.15625 5.15625L4.6875 4.6875"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11.875C10.6904 11.875 11.25 11.3154 11.25 10.625C11.25 9.93464 10.6904 9.375 10 9.375C9.30964 9.375 8.75 9.93464 8.75 10.625C8.75 11.3154 9.30964 11.875 10 11.875Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
    <path
      d="M10 3.75C8.64026 3.75 7.31105 4.15321 6.18046 4.90865C5.04987 5.66408 4.16868 6.73781 3.64833 7.99405C3.12798 9.25029 2.99183 10.6326 3.2571 11.9662C3.52238 13.2999 4.17716 14.5249 5.13864 15.4864C6.10013 16.4478 7.32514 17.1026 8.65876 17.3679C9.99238 17.6332 11.3747 17.497 12.631 16.9767C13.8872 16.4563 14.9609 15.5751 15.7164 14.4445C16.4718 13.314 16.875 11.9847 16.875 10.625C16.875 8.80164 16.1507 7.05295 14.8614 5.76364C13.5721 4.47433 11.8234 3.75 10 3.75Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </SvgIcon>
);
